var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1111 20.3217V33.1106C43.1111 35.4681 42.1746 37.729 40.5076 39.396C38.8406 41.063 36.5797 41.9995 34.2222 41.9995H10.8889C8.53141 41.9995 6.27049 41.063 4.6035 39.396C2.93651 37.729 2 35.4681 2 33.1106V13.1106C2 10.7531 2.93651 8.49216 4.6035 6.82517C6.27049 5.15818 8.53141 4.22168 10.8889 4.22168H26.78",
    stroke: "#FF9C43",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3115L18.1111 22.4893C19.4579 23.2828 20.9925 23.7012 22.5556 23.7012C24.1187 23.7012 25.6533 23.2828 27 22.4893L31.9311 19.696",
    stroke: "#FF9C43",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1112 13.1111C41.1795 13.1111 43.6668 10.6238 43.6668 7.55556C43.6668 4.48731 41.1795 2 38.1112 2C35.043 2 32.5557 4.48731 32.5557 7.55556C32.5557 10.6238 35.043 13.1111 38.1112 13.1111Z",
    stroke: "#FF9C43",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b552a54344167175dcfb5eea23c31c49.svg";
export { ForwardRef as ReactComponent };